import { Card, Progress, Tag, Button, Typography, Spin, Modal } from "antd";
import { BookOutlined, ClockCircleOutlined, DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const { Text } = Typography;

export default function CourseBox(props) {
  const Navigate = useNavigate();
  const [image_loader, set_image_loader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const handleDownload = () => {
    const printWindow = window.open(props.certificate, "_blank");
    printWindow.onload = () => {
      printWindow.print();
    };
  };


  function formatDateTime(isoDate) {
    if (!isoDate) return "N/A";
    const date = new Date(isoDate);
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      // hour: "numeric",
      // // minute: "2-digit",
      // // second: "2-digit",
      // hour12: true
    });
  }


  function renderValidity(validity) {
    if (!validity) return null;

    if (typeof validity === "string" && validity.toLowerCase() === "lifetime") {
      return "LifeTime";
    }

    return formatDateTime(props.validity);
  }


  return (
    <div style={{ position: "relative" }}>
      <Card
        hoverable
        style={{
          width: "100%",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
        bodyStyle={{ padding: 16 }}
        cover={
          <div style={{ position: "relative" }}>
            {/* Image */}
            <img
              src={props.course_image}
              alt="course"
              onLoad={() => set_image_loader(true)}
              style={{
                width: "100%",
                height: "250px",
                objectFit: "cover",
              }}
            />

            {/* Dark overlay */}
            <div
              style={{
                position: "absolute",
                inset: 0,
              }}
            />

            {props.expired && (
              <div
                style={{
                  position: "absolute",
                  top: 10,
                  left: 10,
                  background: "#fff",
                  color: "red",
                  padding: "4px 10px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Expired
              </div>
            )}


            {props.course_ribbon && (
              <div
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "#22c55e",
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                In Package
              </div>
            )}


          </div>
        }
      >
        {/* Title */}
        <Text
          style={{
            fontSize: 16,
            fontWeight: 600,
            display: "block",           // important
            overflow: "hidden",         // hide extra text
            textOverflow: "ellipsis",   // show ...
            whiteSpace: "nowrap",       // single line
          }}
        >
          {props.course_title}
        </Text>



        {/* Description */}
        <div
          style={{
            fontSize: 14,
            color: "#6c757d",
            marginTop: 6,
            height: 40,
          }}
        >
          <div
            style={{
              fontSize: 14,
              color: "#6c757d",
              marginTop: 6,
              height: 20,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            dangerouslySetInnerHTML={{ __html: props.course_tag_line }}
          />
        </div>

        {/* Meta Info */}
        <div
          style={{
            display: "flex",
            gap: 12,
            marginTop: -8,
            fontSize: 15,
            fontWeight: 500,
            color: "#6c757d",
          }}
        >
          {!props.course_ribbon && (
            <span>Valid Till :- {renderValidity(props.validity || "N/A")}{" , "}</span>
          )}
          <span>Chapters :- {props.total_chapters || 0}</span>
        </div>

        {/* Button */}
        <Button
          block
          style={{
            marginTop: 10,
            borderRadius: 8,
            background: "linear-gradient(90deg, #7c3aed, #9333ea)",
            border: "none",
            color: "#fff",
            fontWeight: 500,
          }}
          onClick={() => {
            if (props.expired) {
              setIsModalOpen(true);
            } else {
              Navigate("/view-course/" + props.id);
            }
          }}
        >
          {props.progress === 100 ? "Review" : `Continue (${props.progress}%)`}
        </Button>
      </Card>
      <Modal
        title="Course Expired"
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        okText="OK"
      >
        <p>This course has expired and cannot be accessed.</p>
      </Modal>
    </div>
  );
}
